export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/en-gb.lyaml"));
at({ "en-gb": { "public": { "sampleString": "Sample string" } } });
};